// extracted by mini-css-extract-plugin
export default {"fieldToGroupByText":"bEiIQ"};